import { FC } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { Spinner } from 'summon-ui'
import { Box } from 'summon-ui/mantine'
import { useAccountEffect } from 'wagmi'
import { useLogout, useViewer } from '@hooks'
import useLogin from '@hooks/useLogin'

const withAuth = (WrappedComponent: FC) => {
  const NewComponent: FC = () => {
    const { pathname } = useLocation()
    // sign message when user connects wallet
    const { login } = useLogin()
    const { logout } = useLogout()
    useAccountEffect({
      onConnect: login,
      onDisconnect: logout
    })
    const { viewer, isLoading } = useViewer()
    const isOnboarding = viewer && !viewer?.isOnboardingCompleted

    if (isLoading) {
      return (
        <Box className='h-screen'>
          <Spinner />
        </Box>
      )
    }
    return <>{isOnboarding ? <Navigate to='/onboarding' state={{ redirect: pathname }} /> : <WrappedComponent />}</>
  }

  NewComponent.displayName = 'withAuth'

  return NewComponent
}

export default withAuth
